//
//
//
//
//
//
//
//
//

import HiCell from "../../cell/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";

export default {
  name: "PlanTypeComponent",
  components: { HiCell },
  methods: {
    /**
     * 点击跳转到升级页面
     */
    cellClick() {
      this.$router.push({
        name: "PaymentUpgradePage",
        params: { type: "all" },
      });
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/components/plan/type/Index.vue